import React from "react"
import { MenuItem, TextField } from "@mui/material"

import { STATES, STATE_NAME_MAPPING } from "../../content"
import { GenericStringObj } from "../../types"

export const STATE_ABBVS = STATES.map((state) => state.shortName)

const stateNameMapping: GenericStringObj = STATE_NAME_MAPPING
type StateSelectProps = {
  label: string
  isDisabled?: boolean
  required?: boolean
  fullWidth?: boolean
  allStatesOption?: boolean
  onSelectedCallback: (stateShortName: string) => void
  availableStates?: string[]
  selectedState?: string
  marginTop?: number
}

const StateSelect = ({
  label,
  isDisabled = false,
  required = false,
  fullWidth = false,
  allStatesOption = false,
  onSelectedCallback,
  availableStates = STATE_ABBVS,
  selectedState,
  marginTop = 15,
}: StateSelectProps) => (
  <TextField
    select
    required={required}
    label={label}
    name="usState"
    fullWidth={fullWidth}
    data-cy="us-state-select"
    onChange={(e) => {
      onSelectedCallback(e.target.value)
    }}
    disabled={isDisabled}
    value={selectedState || ""}
    style={{ minWidth: 200, marginTop }}
  >
    {allStatesOption ? (
      <MenuItem value="all" data-cy="state-menu-item">
        All
      </MenuItem>
    ) : null}
    {Object.keys(stateNameMapping)
      .filter((stateKey) => availableStates.includes(stateKey))
      .map((stateKey) => (
        <MenuItem key={stateKey} value={stateKey} data-cy="state-menu-item">
          {stateNameMapping[stateKey]}
        </MenuItem>
      ))}
  </TextField>
)
export default StateSelect
